/**
 * Sport Id for zoom statistics widget
 * @type {number}
 */
export const ZOOM_SOCCER_ID = 61; // Zoom Soccer sportId

/**
 * Get url for the zoom statistics widget
 * @param {number} matchId - Match Id
 * @param {string} tournamentName - Tournament Name
 * @param {boolean} isLive - Flag if match is prematch or live
 * @returns {string} - zoom widget url
 */
export function getZoomUrl(matchId, tournamentName, isLive) {
  const zoomUrl = APP_SETTINGS.statistics.zoomSoccerUrl;
  const clientId = APP_SETTINGS.statistics.zoomClientId;
  const d = new Date();
  let offset = -(d.getTimezoneOffset() * 60000);
  let tName = (tournamentName || '').toLowerCase();
  const statsType = isLive ? 'zoom-scoreboard-mobile' : `zoom/team-statistics/${tName}-zoom`;

  return `${zoomUrl}/${statsType}/?clientId=${clientId}&offset=${offset}&matchId=${matchId}`;
}